import { createAsyncThunk } from "@reduxjs/toolkit";

import FormConfigsAPI, {
  GetFormConfigsResponse,
  GetFormConfigsParams,
} from "../../../api/formConfigs";
import { RootState } from "../../../app/store";

export const fetchFormConfigs = createAsyncThunk<
  GetFormConfigsResponse,
  GetFormConfigsParams | undefined,
  { state: RootState; rejectValue: string }
>(
  "formConfigs/fetchFormConfigs",
  async (params, { rejectWithValue }) => {
    try {
      const response = await FormConfigsAPI.getFormConfigs(params);

      return response;
    } catch {
      return rejectWithValue("Failed to fetch form configs");
    }
  },
  {
    condition(_, { getState }) {
      const formConfigsState = getState().formConfigs;

      if (
        formConfigsState.status === "loading" ||
        formConfigsState.status === "success"
      ) {
        return false;
      }

      return true;
    },
  },
);